import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import HomePage from './pages/home/homePage';
import LoginPage from './pages/login/loginPage';
import ConsolePage from './pages/console/consolePage';
import { logEvent } from 'firebase/analytics';
import { analytics } from './lib/firebaseConfig';
import DocsPage from './pages/docs/docsPage';

const theme = createTheme({
  palette: {
    primary: {
      light: '#60a5fa',  // blue-400
      main: '#3b82f6',   // blue-500
      dark: '#2563eb',   // blue-600
    },
    secondary: {
      light: '#f97316',  // orange-500
      main: '#ea580c',   // orange-600
      dark: '#c2410c',   // orange-700
    },
  },
});

const logPageView = (path: string) => {
  logEvent(analytics, 'screen_view', {
    firebase_screen: path,
    firebase_screen_class: 'App',
  });
};

const App: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/console" element={<ConsolePage />} />
        <Route path="/docs" element={<DocsPage />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;